import * as React from 'react';

type SpinnerProps = {
  colorClass?: string;
  style?: {};
};

export const Spinner = ({ colorClass, style }: SpinnerProps) => (
  <div className="d-flex justify-content-center">
    <div
      className={['spinner-border', colorClass].join(' ')}
      style={style ?? { width: '6rem', height: '6rem' }}
      role="status"
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);
